import { UNSUPPORTED_COUNTRY_KEYS } from './constants';
export function filterUnsupportedCountries(countries) {
    return countries.filter(function (x) { return !UNSUPPORTED_COUNTRY_KEYS.includes(x.key); });
}
//# sourceMappingURL=unsupportedCountriesFilter.js.map